export const LANGUAGE_KEY = 'APP_LANGUAGE';

export default {
  state: {
    language: localStorage.getItem(LANGUAGE_KEY) || 'zh-CN'
  },
  getters: {
    getLanguage: state => state.language,
  },
  mutations: {
    setLanguage: (state, lang) => {
      state.language = lang;
      localStorage.setItem(LANGUAGE_KEY, lang);
    }
  },
  actions: {
    setLanguage: ({ commit }, lang) => {
      commit('setLanguage', lang);
    },
    initLanguage: ({ commit }) => {
      const savedLang = localStorage.getItem(LANGUAGE_KEY);
      if (savedLang) {
        commit('setLanguage', savedLang);
      } else {
        commit('setLanguage', 'zh-CN');
      }
    }
  }
};
